<template>
    <v-container class="w-container-creaz-coll v-overflow editCreazColl"
        style="padding-top: 59px;background-color: rgb(255 255 255 / 50%);">

        <v-row>


            <v-col class='mainCont' style="min-width:100vw;position:fixed;left:0;padding-left:0px;z-index:3">

                <div class="mainTitle" style="
                background-color: white;
                color: black;
                font-weight: bold;
                padding: 4px;
                font-size: 10px;
                min-width:100vw;
                border-color:#f5cf2e">{{ titolo }}</div>

            </v-col>

        </v-row>


        <v-form style="max-width:500px;" v-model="valid" ref="form" lazy-validation>


            <v-row>

                <v-col cols="12" md="12">

                    <div id="cont_companyid" style="cursor:pointer">
                        <ion-item id="itemCompany"
                            style="min-width:190px!important;transform: translateX(-6px);margin-top:-24px;margin-bottom:18px">

                            <ion-label style="font-size:12px;color:gray!important;opacity:1;cursor:pointer"
                                position="floating">Azienda </ion-label>

                            <ion-select id="companyid" name="companyid" class='companyid' cancel-Text="Chiudi"
                                done-Text="" :value="aziendaCandidato" interface="action-sheet" disabled readonly>

                                <ion-select-option v-for="item in aziende" :key="item.companyid"
                                    :value='item.companyid'> {{ item.fld_name }}</ion-select-option>

                            </ion-select>
                        </ion-item>
                    </div>

                </v-col>

            </v-row>

            <v-row>

                <v-col cols="12" md="12">

                    <div id="cont_candidatoid" style="cursor:pointer">
                        <ion-item id="itemCompany"
                            style="min-width:190px!important;transform: translateX(-6px);margin-top:-24px;margin-bottom:18px">

                            <ion-label style="font-size:12px;color:gray!important;opacity:1;cursor:pointer"
                                position="floating">Candidato </ion-label>

                            <ion-select id="candidatoid" name="candidatoid" class='candidatoid' cancel-Text="Chiudi"
                                done-Text="" :value="idCandidato" interface="action-sheet" disabled readonly>

                                <ion-select-option v-for="item in candidati" :key="item.id" :value='item.id'> {{
                                    item.full_name }}</ion-select-option>

                            </ion-select>
                        </ion-item>
                    </div>

                </v-col>

            </v-row>

            <v-row>

                <v-col cols="12" md="12">

                    <v-text-field v-model="nomeCandidato" label="Nome" readonly></v-text-field>

                </v-col>

            </v-row>

            <v-row>

                <v-col cols="12" md="12">

                    <v-text-field v-model="cognomeCandidato" label="Cognome" readonly></v-text-field>

                </v-col>

            </v-row>

            <v-row>

                <v-col cols="12" md="12">

                    <v-text-field v-model="mailCandidato" label="E-Mail" readonly></v-text-field>

                </v-col>

            </v-row>

            <v-row>

                <v-col cols="12" md="12">

                    <div id="cont_tipo_contratto" style="cursor:pointer">
                        <ion-item id="itemTipoContratto"
                            style="min-width:190px!important;transform: translateX(-6px);margin-top:-24px;margin-bottom:18px">

                            <ion-label style="font-size:12px;color:gray!important;opacity:1;cursor:pointer"
                                position="floating">Tipo Contratto </ion-label>

                            <ion-select id="tipo_contratto_impiegato" name="tipo_contratto_impiegato"
                                class='tipo_contratto_impiegato' cancel-Text="Chiudi" done-Text=""
                                :value="tipoContrattoCandidato" interface="action-sheet">

                                <ion-select-option v-for="item in tipi_contratto" :key="item.contratto"
                                    :value='item.contratto'> {{ item.descrizione }}</ion-select-option>

                            </ion-select>
                        </ion-item>
                    </div>

                </v-col>

            </v-row>



        </v-form>

        <div class="contaziende">

            <template>
                <div class="text-center">
                    <v-bottom-sheet v-model="sheetAziende" class="vaziendesheet">
                        <v-sheet class="text-center" height="100vh">
                            <div class="headerSheetAziende" fixed style="position:fixed;">
                                Aziende
                                <v-btn class='closeSheet align_close_sheet' icon @click="sheetAziende = !sheetAziende">

                                    <v-img alt="" src="@/assets/btn_cancel3_emt.png" max-width="24" max-height="24"
                                        style="margin-right:10px" />

                                </v-btn>

                                <v-toolbar>
                                    <v-text-field hide-details prepend-icon="mdi-magnify" single-line v-model="search">
                                    </v-text-field>

                                </v-toolbar>

                            </div>

                            <v-divider></v-divider>

                            <div class="spacer" style="min-height:72px;"></div>

                            <v-flex xs12 sm12>
                                <v-card>

                                    <v-list-item class="text-left" v-for="item in filteredAziende" :key="item.companyid"
                                        @click="manageClickAziende(item)">

                                        <v-img alt="" src="@/assets/aziende-emt.png" max-width="24" max-height="24" />

                                        <v-list-item-title class='itemAzienda'>{{ item.fld_name }}</v-list-item-title>
                                    </v-list-item>

                                    <div style="min-height:150px;height:150px">&nbsp;</div>

                                </v-card>
                            </v-flex>
                        </v-sheet>
                    </v-bottom-sheet>
                </div>
            </template>

        </div>

        <div class="contpopupaddmail">

            <template>
                <modal name="popupAddMail" :clickToClose="false" :width="365" :height="600">


                    <v-row>

                        <v-col cols="12" md="12" style="margin-top:10px!important;font-weight:bold;margin-left:10px">

                            Candidati

                        </v-col>

                    </v-row>



                    <div style="height: 439px;">


                        <v-row
                            style="margin-top:-20px!important;padding-top: 0px!important;margin-bottom: 0px!important;padding-bottom: 0px!important;">

                            <v-col cols="12" md="12" xs="12"
                                style="margin-top:0px!important;padding-top: 0px!important;margin-bottom: 0px!important;padding-bottom: 0px!important;">

                                <v-text-field hide-details prepend-icon="mdi-magnify" single-line
                                    v-model="searchCandidato" style="width:343px">
                                </v-text-field>

                            </v-col>

                            <v-col cols="12" md="6" xs="6"
                                style="padding-bottom:0px!important;margin-bottom:0px!important">

                            </v-col>

                        </v-row>

                        <v-row style="padding-top:0px!important;margin-top:0px!important">

                            <v-col cols=" 12" md="12" xs="12"
                                style="padding-top:0px!important;margin-top:0px!important">

                                <v-list style="overflow-y:auto;max-height: 439px;;min-height: 439px;">

                                    <v-list-tile v-for="el in filteredCandidati" :key="el.id">

                                        <div style="display:flex!important;height:30px;align-items:top;">

                                            <div style="width:30px;text-align: center;">
                                                <input type="checkbox" class="email-checkbox"
                                                    style="transform: scale(0.75); transform-origin: top left;margin-top:2px;accent-color: #ffd212;"
                                                    :data-email="el.mail" :data-fullname="el.full_name"
                                                    :checked="selectedEmail === el.mail"
                                                    @change="selectEmail(el.mail)" />
                                            </div>




                                            <div style="width:150px;margin-left:10px">{{ el.full_name }}</div>

                                            <div style="width:200px">{{ el.mail }}</div>


                                        </div>

                                    </v-list-tile>

                                </v-list>

                            </v-col>


                        </v-row>



                    </div>




                    <v-row style="margin-top:92px">

                        <v-col cols="12" md="12">

                            <div style="display:flex;justify-content:center">

                                <v-img alt="" class="btn-cancel-add-mail-dest" contain
                                    src="@/assets/btn_cancel3_emt.png" max-width="30" max-height="30"
                                    style="cursor:pointer;color:black;margin-right:10px" transition="scale-transition"
                                    @click="btnCancelAddMailsDest" title="Cancel" />

                                <v-img alt="" class="btn-confirm-add-mail-dest" contain
                                    src="@/assets/btn_confirm3_emt.png" max-width="32" max-height="32"
                                    style="cursor:pointer" transition="scale-transition" @click="btnConfirmAddMailsDest"
                                    title="Confirm" />


                            </div>

                        </v-col>

                    </v-row>

                </modal>
            </template>

        </div>


        <div class="contcandidati">

            <template>
                <div class="text-center">
                    <v-bottom-sheet v-model="sheetCandidati" class="vaziendesheet">
                        <v-sheet class="text-center" height="100vh">
                            <div class="headerSheetAziende" fixed style="position:fixed;">
                                Candidati
                                <v-btn class='closeSheet align_close_sheet' icon
                                    @click="sheetCandidati = !sheetCandidati">

                                    <v-img alt="" src="@/assets/profilo3.png" max-width="24" max-height="24"
                                        style="margin-right:10px" />

                                </v-btn>

                                <v-toolbar>
                                    <v-text-field hide-details prepend-icon="mdi-magnify" single-line
                                        v-model="searchCandidato">
                                    </v-text-field>

                                </v-toolbar>

                            </div>

                            <v-divider></v-divider>

                            <div class="spacer" style="min-height:72px;"></div>

                            <v-flex xs12 sm12>
                                <v-card>

                                    <v-list-item class="text-left" v-for="item in filteredCandidati"
                                        :key="item.companyid" @click="manageClickCandidati(item)">

                                        <v-img alt="" src="@/assets/profilo3.png" max-width="24" max-height="24" />

                                        <v-list-item-title class='itemAzienda'>{{ item.full_name }}</v-list-item-title>
                                    </v-list-item>

                                    <div style="min-height:150px;height:150px">&nbsp;</div>

                                </v-card>
                            </v-flex>
                        </v-sheet>
                    </v-bottom-sheet>
                </div>
            </template>

        </div>




    </v-container>
</template>

<script>
import apiusers from "../utils/users/apiusers";
import apicespiti from "../utils/cespiti/apicespiti";
import apitimesheet from "../utils/timesheet/apitimesheet";

import {
    bus
} from "../main";

import router from ".././router";

import Vue from "vue";
import VModal from 'vue-js-modal';

import * as pdfjsLib from 'pdfjs-dist';
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';

export default ({
    mounted() {

        this.$root.$children[0].checkLogout();

        Vue.use(VModal, {
            dialog: true
        });

        /*eslint-disable no-undef*/

        var pointerVue = this;

        //window.$cookies.get("aziende_user")

        this.setupButtons();

        setTimeout(() => {


            this.syncAziende();

            this.syncCandidati();


        }, 100);




        bus.$on("bottomIconClickEvent", (data) => {
            //this.header = data;
            console.log(data);
            switch (data) {

                case "btn_confirm":

                    this.validate();

                    break;

                default:
                    break;
            }
        });

        $(document).ready(function () {

            $('body').on('click', '#cont_candidatoid', function (event) {
                console.log(event);

                pointerVue.sheetCandidati = true;

            });




            $('body').on('click', '.clSelPopupCandidati', function (event) {
                console.log(event);

                pointerVue.openPopupAddMail();


            });








            $('body').on('ionChange', '.tipo_contratto_impiegato', function (event) {
                console.log(event);

                pointerVue.tipoContrattoCandidato = this.value;

            });








            $('body').on('click', '#cont_companyid', function (event) {
                console.log(event);

                pointerVue.sheetAziende = true;

            });


            $('body').on('click', '.btn-confirm-fido-ant', function (event) {
                console.log(event);

                pointerVue.banca.fido_anticipi = pointerVue.fidoAnt;

                pointerVue.$root.$children[0].setFieldActive("#d_fido_ant");

                pointerVue.$modal.hide('popupFidoAnt');

            });


            $('body').on('click', '.btn-cancel-fido-ant', function (event) {
                console.log(event);

                pointerVue.$modal.hide('popupFidoAnt');

            });

            $('body').on('click', '#d_fido_ant', function (event) {
                console.log(event);


                pointerVue.$modal.show('popupFidoAnt');

            });


            $('body').on('click', '#cont_idresource', function (event) {
                console.log(event);

                pointerVue.sheetRisorse = true;

            });



            $('body').on('click', '#cont_idmailgroup', function (event) {
                console.log(event);

                pointerVue.sheetGruppi = true;

            });




            $('body').on('click', '#d_importo_user', function (event) {
                console.log(event);

                pointerVue.$modal.show('popupImporto');

            });


            $('body').on('click', '.btn-confirm-massimale', function (event) {
                console.log(event);

                pointerVue.utente.max_easyer = pointerVue.valoreMassimale;

                pointerVue.$root.$children[0].setFieldActive("#d_importo_user");

                pointerVue.$modal.hide('popupImporto');

            });

            $('body').on('click', '.btn-cancel-massimale', function (event) {
                console.log(event);

                pointerVue.$modal.hide('popupImporto');

            });






            $('body').on('click', '.btn-confirm-fido-cassa', function (event) {
                console.log(event);

                pointerVue.banca.fido_cassa = pointerVue.fidoCassa;

                pointerVue.$root.$children[0].setFieldActive("#d_fido_cassa");

                pointerVue.$modal.hide('popupFidoCassa');

            });


            $('body').on('click', '.btn-cancel-fido-cassa', function (event) {
                console.log(event);

                pointerVue.$modal.hide('popupFidoCassa');

            });

            $('body').on('click', '#d_fido_cassa', function (event) {
                console.log(event);


                pointerVue.$modal.show('popupFidoCassa');

            });


            setTimeout(() => {

                var oggDrop = $('.dropify').dropify({
                    messages: {
                        default: 'Drag',
                        replace: /* s */ '',
                        remove: 'Rimuovi',
                        error: 'File troppo grande'
                    }
                });

                $(".dropify-clear").html("<img src='https://app.smart-book.it/_lib/img/icons8-cestino-64.png' />")
                $(".dropify-render").append("<img>");

                //console.log(oggDrop);

                oggDrop.on('dropify.afterClear', function (event, element) {

                    console.log(event, element);

                    pointerVue.attachRemove = true;

                });

            }, 100);


            $(".idassettype").on("ionChange", function (opt) {
                console.log(opt);

                if ((this.value == 4) || (this.value == 1) || (this.value == 2) || (this.value == 3)) {

                    pointerVue.visDescrizione = true;
                    pointerVue.visNMatricola = true;
                    pointerVue.visOP = true;
                    pointerVue.visSw = true;

                    pointerVue.visMemNB = true;
                    pointerVue.visDiscoNB = true;


                    pointerVue.visNSim = false;
                    pointerVue.visTelNum = false;

                    pointerVue.visTarga = false;
                    pointerVue.visVeicolo = false;


                    pointerVue.visPollici = false;


                }


                if ((this.value == 5) || (this.value == 6)) {

                    pointerVue.visDescrizione = false;
                    pointerVue.visNMatricola = false;
                    pointerVue.visOP = false;
                    pointerVue.visSw = false;

                    pointerVue.visMemNB = false;
                    pointerVue.visDiscoNB = false;


                    pointerVue.visNSim = true;
                    pointerVue.visTelNum = true;

                    pointerVue.visTarga = false;
                    pointerVue.visVeicolo = false;

                    pointerVue.visPollici = false;


                }

                if (this.value == 7) {

                    pointerVue.visDescrizione = false;
                    pointerVue.visNMatricola = false;
                    pointerVue.visOP = false;
                    pointerVue.visSw = false;


                    pointerVue.visMemNB = false;
                    pointerVue.visDiscoNB = false;


                    pointerVue.visNSim = false;
                    pointerVue.visTelNum = false;

                    pointerVue.visTarga = true;
                    pointerVue.visVeicolo = true;

                    pointerVue.visPollici = false;


                }

                if (this.value == 9) {

                    pointerVue.visDescrizione = true;
                    pointerVue.visNMatricola = false;
                    pointerVue.visOP = false;
                    pointerVue.visSw = false;

                    pointerVue.visMemNB = false;
                    pointerVue.visDiscoNB = false;


                    pointerVue.visNSim = false;
                    pointerVue.visTelNum = false;

                    pointerVue.visTarga = false;
                    pointerVue.visVeicolo = false;

                    pointerVue.visPollici = false;


                }


                if (this.value == 10) {

                    pointerVue.visDescrizione = true;
                    pointerVue.visNMatricola = false;
                    pointerVue.visOP = false;
                    pointerVue.visSw = false;

                    pointerVue.visMemNB = false;
                    pointerVue.visDiscoNB = false;


                    pointerVue.visNSim = false;
                    pointerVue.visTelNum = false;

                    pointerVue.visTarga = false;
                    pointerVue.visVeicolo = false;

                    pointerVue.visTipoDisco = true;

                    pointerVue.visPollici = false;


                }


                if (this.value == 11) {

                    pointerVue.visDescrizione = true;
                    pointerVue.visNMatricola = false;
                    pointerVue.visOP = false;
                    pointerVue.visSw = false;

                    pointerVue.visMemNB = false;
                    pointerVue.visDiscoNB = false;


                    pointerVue.visNSim = false;
                    pointerVue.visTelNum = false;

                    pointerVue.visTarga = false;
                    pointerVue.visVeicolo = false;

                    pointerVue.visTipoDisco = false;

                    pointerVue.visPollici = true;



                }



            });




        });

    },



    computed: {

        filteredAziende() {

            return _.orderBy(this.aziende.filter(item => {
                if (!this.search) return this.aziende;
                return (item.fld_name.toLowerCase().includes(this.search.toLowerCase()));
            }), 'headline')
        },

        filteredGruppi() {

            return _.orderBy(this.gruppi.filter(item => {
                if (!this.searchGruppi) return this.gruppi;
                return (item.name.toLowerCase().includes(this.searchGruppi.toLowerCase()));
            }), 'headline')
        },

        filteredRisorse() {

            return _.orderBy(this.risorse.filter(item => {
                if (!this.search) return this.risorse;
                return (item.resource.toLowerCase().includes(this.search.toLowerCase()));
            }), 'headline')
        },

        filteredCandidati() {

            return _.orderBy(this.candidati.filter(item => {
                if (!this.searchCandidato) return this.candidati;
                return (item.full_name.toLowerCase().includes(this.searchCandidato.toLowerCase()));
            }), 'headline')
        },


    },

    data: () => ({

        sheetCandidati: false,

        searchCandidati: "",

        idCandidato: "",

        candidatiTemp: [],


        selectedEmail: null,

        candidati: [],

        searchCandidato: "",

        tipoContrattoCandidato: "",

        tipi_contratto: [
            {
                contratto: "APS",
                descrizione: "Apprendistato"
            },
            {
                contratto: "CINT",
                descrizione: "Cassa Integrazione"
            },
            {
                contratto: "DET",
                descrizione: "Determinato (IT)"
            },
            {
                contratto: "DIS",
                descrizione: "Disoccupato"
            },
            {
                contratto: "FOR",
                descrizione: "Fornitore"
            },
            {
                contratto: "IND",
                descrizione: "Indeterminato (IT)"
            },
            {
                contratto: "MOB",
                descrizione: "Mobilità"
            },
            {
                contratto: "PIVA",
                descrizione: "Partita IVA"
            },
            {
                contratto: "RIT",
                descrizione: "Ritenuta"
            },
            {
                contratto: "STG",
                descrizione: "Stage"
            },
            {
                contratto: "TCN",
                descrizione: "Tirocinio"
            }

        ],

        mailCandidato: "",

        nomeCandidato: "",

        cognomeCandidato: "",

        aziendaCandidato: "",

        pdfUrl: "",

        visMemNB: false,
        visDiscoNB: false,

        risNomeSede: "",

        attachRemove: false,

        sheetRisorse: false,

        fidoAnt: null,
        fidoCassa: null,

        visDescrizione: false,
        visNMatricola: false,
        visOP: false,
        visSw: false,

        visNSim: false,
        visTelNum: false,

        visTarga: false,
        visVeicolo: false,

        visTipoDisco: false,

        visPollici: false,



        sheetGruppi: false,

        searchGruppi: "",

        tipo_cespiti: [],

        risorse: [],

        banca: {},

        cespiti: {
            hours: null
        },

        showPicker2: false,

        valoreMassimale: null,

        changePsw: false,

        titolo: "Creazione Collaboratore",
        currDipendenteObj: {},

        gruppi_checked: [],

        isCurrentUserSU: "N",

        aziende: [],
        prefissi: [],

        dipendenti: [],
        currAzienda: "",

        gruppi: [],

        selNuclei: null,

        tab: null,

        cur_id: 0,

        sheetAziende: false,
        sheetDipendenti: false,
        searchDipendenti: "",
        search: "",

        showPicker: false,
        utente: {},
        valid: true,
        initials: "",
        namesurname: "",
        iban: "",
        cellulare: "",
        codicefiscale: "",
        codicefiscaleRules: [
            (v) => !!v || "Codice fiscale is required",
            (v) => (v && v.length <= 16) || "Codice fiscale must be less than 16 characters",
        ],
        cellulareRules: [
            (v) => !!v || "Phone number is required",
            (v) => (v && v.length <= 30) || "Phone number must be less than 15 characters",
        ],
        genRules: [
            (v) => !!v || "Field required",

        ],
        ibanRules: [
            (v) => !!v || "Iban is required",
            (v) => (v && v.length <= 30) || "Iban must be less than 30 characters",
        ],
        email: "",
        emailRules: [
            (v) => !!v || "E-mail richiesta",
            (v) => /.+@.+\..+/.test(v) || "E-mail non valida",
        ],

        nameRules: [
            (v) => !!v || "Nome richiesto",
        ],

        phoneRules: [
            (v) => !!v || "Telefono richiesto",
        ],

        nucleoRules: [
            (v) => !!v || "Nucleo richiesto",
        ],

        fiscodeRules: [
            (v) => !!v || "Codice fiscale richiesto",
        ],

        surnameRules: [
            (v) => !!v || "Cognome richiesto",
        ],

        aziendaRules: [
            (v) => !!v || "Azienda richiesta",
        ],

        usernameRules: [
            (v) => !!v || "Username richiesto",
        ],

        select: null,

        // items: [
        //     'Informazioni Generali', 'Gruppo', 'Autenticazione', 'QR Code'
        // ],

        items: [
            'Informazioni', 'Gruppo', 'Nota Spese'
        ],

        checkbox: false,

        tipo_qrcode: [{
            "id": "USR_PWD",
            "value": "Utente E Password"
        },
        {
            "id": "FCODE_PWD",
            "value": "Utente E Codice Fiscale"
        }
        ],

        tipi_dischi: [{
            "id": "RPM",
            "value": "RPM"
        },
        {
            "id": "SSD",
            "value": "SSD"
        }
        ]

    }),

    methods: {

        getDatiCandidato: function (id_candidato) {

            var v_nome = "";
            var v_cognome = "";
            var v_mail = "";

            for (var xx = 0; xx < this.candidati.length; xx++) {

                if (this.candidati[xx].id == id_candidato) {
                    v_nome = this.candidati[xx].nome;
                    v_cognome = this.candidati[xx].cognome;
                    v_mail = this.candidati[xx].mail;
                }

            }

            this.nomeCandidato = v_nome;
            this.cognomeCandidato = v_cognome;
            this.mailCandidato = v_mail;


        },


        manageClickCandidati: async function (candidato) {

            console.log("CANDIDATO SEL: ", candidato);

            this.sheetCandidati = false;

            this.idCandidato = candidato.id;

            this.getDatiCandidato(candidato.id);


        },


        setCandidati: function (id_azienda) {

            console.log("AZI SEL 2: ", id_azienda);

            console.log("CANDIDATI TMP: ", this.candidatiTemp);

            var Candidati = [];

            for (var i = 0; i < this.candidatiTemp.length; i++) {

                if (parseInt(this.candidatiTemp[i].companyid) == parseInt(id_azienda)) {

                    Candidati.push({
                        id: this.candidatiTemp[i].id,
                        full_name: this.candidatiTemp[i].full_name + " (" + this.candidatiTemp[i].mail + ")",
                        mail: this.candidatiTemp[i].mail,
                        companyid: this.candidatiTemp[i].companyid,
                        cognome: this.candidatiTemp[i].cognome,
                        nome: this.candidatiTemp[i].nome,
                    });

                }

            }

            console.log("CANDIDATI SEL: ", Candidati);

            this.candidati = Candidati;

        },

        syncCandidati: async function () {

            var that = this;

            var response = null;

            var v_token = window.$cookies.get("token");

            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;


            response = await apitimesheet.getDataMailsDestinations(
                v_token
            ).then((res) => {

                that.$root.$children[0].showProgress = false;
                console.log("res from getDataMailsDestinations", res);

                that.candidatiTemp = res.data.Candidati;



            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("ERrori", "Non è stato possibile salvare i dati");
                console.log("response", response);

            }

            );


        },


        selectEmail(email) {
            this.selectedEmail = this.selectedEmail === email ? null : email;
        },

        openPopupAddMail: async function () {


            var that = this;

            var response = null;

            var v_token = window.$cookies.get("token");

            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;


            response = await apitimesheet.getDataMailsDestinations(
                v_token
            ).then((res) => {

                that.$root.$children[0].showProgress = false;
                console.log("res from getDataMailsDestinations", res);

                that.candidati = res.data.Candidati;

                that.searchCandidato = "";

                that.selectedEmail = null;

                setTimeout(() => {

                    $(".contpopupaddmail").show();

                    that.$modal.show('popupAddMail');

                }, 300);


            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("ERrori", "Non è stato possibile salvare i dati");
                console.log("response", response);

            }

            );



        },

        btnCancelAddMailsDest: function () {

            this.$modal.hide('popupAddMail');

        },

        btnConfirmAddMailsDest: function () {

            var that = this;

            var errore = "";

            if (that.selectedEmail == null) {
                errore = "Selezionare una mail";
            }


            if (errore == "") {

                console.log("ok");


                that.mailCandidato = that.selectedEmail;



                that.$modal.hide('popupAddMail');

            }
            else {

                that.$swal({
                    icon: "error",
                    text: errore,
                    showConfirmButton: false,
                    timer: 3000
                });


            }

        },


        isEmail: function (email) {
            //return email;
            if (email.length == 0) return true;
            //eslint-disable-next-line
            var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
            return regex.test(email);
        },


        syncConfTicket: async function () {

            var that = this;


            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            var response = await apitimesheet.getConfTicket(
                0
            ).then(async (res) => {

                that.$root.$children[0].showProgress = false;

                console.log("res from getConfTicket", res);

                that.cespiti.hours = res.data.Result.hours;


            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("Errori", "Non è stato possibile eliminare i dati");
                console.log("response", response);

            }

            );

        },


        btnResetSignatureViewFile: function () {

            window.signaturePad.clear();

        },

        saveSignatureViewFile: async function () {

            var that = this;

            that.$modal.hide('popupSignatureViewFile');


            var signature = window.signaturePad.toDataURL();

            console.log("SIGNATURE: ", signature);

            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            var response = await apicespiti.saveSignatureCespiti(
                that.$route.params.id,
                signature
            ).then(async (res) => {

                that.$root.$children[0].showProgress = false;

                console.log("res from saveSignatureCespiti", res);



                that.viewAllegato();



            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("Errori", "Non è stato possibile eliminare i dati");
                console.log("response", response);

            }

            );



        },



        btnConfirmSignatureViewFile: function () {

            var errore = "";

            if (window.signaturePad.isEmpty()) {
                errore = "Firma richiesta";
            }

            if (errore == "") {

                console.log("ok");

                this.saveSignatureViewFile();

            }
            else {

                this.$swal({
                    icon: "error",
                    text: errore,
                    showConfirmButton: false,
                    timer: 2000
                });

            }



        },


        viewAllegato: async function () {

            var that = this;



            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            var response = await apicespiti.downAttach(
                that.$route.params.id
            ).then((res) => {

                that.$root.$children[0].showProgress = false;
                console.log("res from downAttach", res);

                setTimeout(() => {


                    $(".contpopupviewfilepdf").show();

                    that.$modal.show('popupViewFilePdf');

                    that.pdfUrl = res.data.UrlVal;

                    setTimeout(() => {


                        that.loadPdf();

                        that.centerPopupViewFilePdf();


                    }, 200);



                }, 100);







            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("Errori", "Non è stato possibile eliminare i dati");
                console.log("response", response);

            }

            );

        },


        centerPopupViewFilePdf: function () {



            var windowWidth = $(window).width();
            var windowHeight = $(window).height();


            var divWidth = Math.ceil((90 / 100) * windowWidth);
            var divHeight = Math.ceil((65 / 100) * windowHeight);


            var leftPosition = (windowWidth - divWidth) / 2;
            var topPosition = (windowHeight - divHeight) / 2;

            $('#pViewFilePdf').find('.vm--modal').css({
                'position': 'absolute',
                'left': leftPosition + 'px',
                'top': topPosition + 'px',
                'width': divWidth + 'px',
                'height': divHeight + 'px'
            });


        },


        async loadPdf() {

            pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;

            const pdfContainer = document.getElementById('container-view-pdf');
            pdfContainer.innerHTML = '';

            try {
                const pdf = await pdfjsLib.getDocument(this.pdfUrl).promise;
                for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
                    const page = await pdf.getPage(pageNum);
                    const viewport = page.getViewport({ scale: 1.5 });

                    const canvas = document.createElement('canvas');
                    const context = canvas.getContext('2d');
                    canvas.height = viewport.height;
                    canvas.width = viewport.width;

                    const renderContext = {
                        canvasContext: context,
                        viewport: viewport
                    };

                    await page.render(renderContext).promise;

                    pdfContainer.appendChild(canvas);
                }
            } catch (error) {
                console.error('Error loading PDF: ', error);
            }
        },

        btnCancelViewFilePdf: function () {

            var that = this;

            that.$modal.hide('popupViewFilePdf');

            setTimeout(() => {

                that.dialogMsg = false;
                that.setupButtons();

                router.push({
                    path: "/cespiti"
                });

            }, 200);

        },




        manageClickRisorse: async function (risorsa) {

            console.log("RIS SEL: ", risorsa);

            this.sheetRisorse = false;

            this.cespiti.idresource = risorsa.resourceid;

            this.syncOfficeRes(risorsa.resourceid);

        },




        manageClickAziende: async function (azienda) {

            console.log("AZI SEL: ", azienda);

            this.sheetAziende = false;

            this.aziendaCandidato = azienda.companyid;

            this.setCandidati(azienda.companyid);

        },

        manageClickGruppi: async function (gruppo) {

            console.log("GRP SEL: ", gruppo);

            this.sheetGruppi = false;

            this.banca.idmailgroup = gruppo.idmailgroup;

        },


        setupButtons: async function () {

            setTimeout(() => {

                var pulsantis = [{
                    text: "Conferma",
                    icon: "mdi-content-save",
                    image: "https://app.emtool.eu/public/_lib/img/conferma-prjweb.png",
                    link: "/timesheet",
                    id: "btn_confirm",
                    disabled: false,
                    title: "Conferma",
                    width: 30
                },

                ];

                this.$root.$children[0].bnavbuttons = pulsantis;

                setTimeout(() => {
                }, 100);

            }, 100);

        },

        validate() {

            var that = this;


            var errore = "";


            if (that.aziendaCandidato == "") {
                errore = "Specificare l'azienda";
            }

            if (errore == "") {
                if (that.idCandidato == "") {
                    errore = "Specificare il candidato";
                }
            }

            if (errore == "") {
                if (that.nomeCandidato == "") {
                    errore = "Specificare il nome";
                }
            }

            if (errore == "") {
                if (that.cognomeCandidato == "") {
                    errore = "Specificare il cognome";
                }
            }

            if (errore == "") {
                if (that.mailCandidato == "") {
                    errore = "Specificare la mail";
                }
            }

            if (errore == "") {
                if (!that.isEmail(that.mailCandidato)) {
                    errore = "E-Mail non valida";
                }
            }


            if (errore == "") {
                if (that.tipoContrattoCandidato == "") {
                    errore = "Specificare il tipo contratto";
                }
            }



            if (errore == "") {



                console.log("ok");

                that.sendMail();

            }
            else {

                that.$swal({
                    icon: "error",
                    text: errore,
                    showConfirmButton: false,
                    timer: 2000
                });


            }



        },

        sendMail: async function () {



            var that = this;

            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            response = await apitimesheet.sendMailCreateColl(
                that.aziendaCandidato,
                that.nomeCandidato,
                that.cognomeCandidato,
                that.mailCandidato,
                that.tipoContrattoCandidato
            ).then((res) => {

                that.$root.$children[0].showProgress = false;
                console.log("res from sendMailCreateColl", res);

                that.$swal({
                    icon: "success",
                    text: "Mail inviata correttamente",
                    showConfirmButton: false,
                    timer: 2000
                });



                setTimeout(() => {

                    router.push({
                        path: "/initDash"
                    });

                }, 2000);



            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("ERrori", "Non è stato possibile salvare i dati");
                console.log("response", response);

            }

            );









        },

        syncUtente: async function () {

            var that = this;

            var v_token = window.$cookies.get("token");

            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            var response = await apiusers.getUtente(
                that.$route.params.id,
                v_token
            ).then((res) => {

                that.$root.$children[0].showProgress = false;
                console.log("res from getUtente", res);

                try {

                    this.aziende = res.data.aziende;
                    this.prefissi = res.data.prefix;
                    this.gruppi = res.data.models;
                    this.utente = res.data.curr_user;

                    this.utente.codice_fiscale = res.data.val_codice_fiscale;

                    if (res.data.curr_user.models != null) {

                        var grp_selected = res.data.curr_user.models.split(",");

                        console.log("GRP SEL: ", grp_selected);

                        if (grp_selected.length > 0) {

                            for (var i = 0; i < this.gruppi.length; i++) {

                                if (this.gruppi[i] !== undefined) {

                                    for (var x = 0; x < grp_selected.length; x++) {

                                        console.log("GRP SEL 2: ", grp_selected[x]);

                                        if (parseInt(this.gruppi[i].id) == parseInt(grp_selected[x])) {

                                            this.gruppi[i].checked = this.gruppi[i].id;

                                        }

                                    }

                                }

                            }

                        }


                    }




                    $("#itemAzienda").addClass("item-has-value");


                    console.log("USER INFO EASYER: ", res.data.info_easyer);


                    if (res.data.info_easyer != null) {

                        this.utente.enable_easyer = res.data.info_easyer.enable;

                        this.utente.max_easyer = res.data.info_easyer.max_value;

                        this.utente.datestart_easyer = res.data.info_easyer.period_from;

                        this.utente.dateend_easyer = res.data.info_easyer.period_to;


                    }






                    //console.log("ok");

                } catch (error) {
                    console.log(error);
                }

            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("ERrori", "Non è stato possibile caricare i dati");
                console.log("response", response);

            }

            );

        },

        syncAziende: function () {

            var that = this;

            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            setTimeout(() => {

                that.$root.$children[0].showProgress = false;

                that.aziende = JSON.parse(window.$cookies.get("companyUser"));

            }, 300);


        },


        syncMailGroup: async function () {

            var that = this;

            var v_token = window.$cookies.get("token");

            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            var response = await apibanche.getGruppi(
                v_token
            ).then((res) => {

                that.$root.$children[0].showProgress = false;
                console.log("res from syncMailGroup", res);

                this.gruppi = res.data.invoice_mail_group;



            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("Errori", "Non è stato possibile caricare i dati");
                console.log("response", response);

            }

            );

        },


        syncInitInsert: async function () {

            var that = this;

            var v_token = window.$cookies.get("token");

            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            var response = await apicespiti.initInsert(
                v_token
            ).then((res) => {

                that.$root.$children[0].showProgress = false;
                console.log("res from initInsert", res);


                this.tipo_cespiti = res.data.asset_type;

                this.risorse = res.data.resource;



                // this.aziende = res.data.aziende;

                // this.gruppi = res.data.invoice_mail_group;

                // this.banca = res.data.banca;


            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("Errori", "Non è stato possibile caricare i dati");
                console.log("response", response);

            }

            );

        },



        syncOfficeRes: async function (id_resource) {

            var that = this;

            var v_token = window.$cookies.get("token");

            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            var response = await apicespiti.getOfficeRes(
                v_token,
                id_resource
            ).then((res) => {

                that.$root.$children[0].showProgress = false;
                console.log("res from getOfficeRes", res);

                this.risNomeSede = res.data.DescOffice;



            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("Errori", "Non è stato possibile caricare i dati");
                console.log("response", response);

            }

            );

        },



        syncAsset: async function () {

            var that = this;

            var v_token = window.$cookies.get("token");

            var id_cmp_sel = window.$cookies.get("cid");

            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            var response = await apicespiti.initEdit(
                that.$route.params.id,
                v_token,
                id_cmp_sel
            ).then((res) => {

                that.$root.$children[0].showProgress = false;
                console.log("res from initEdit", res);


                this.tipo_cespiti = res.data.asset_type;

                this.risorse = res.data.resource;

                this.cespiti = res.data.asset;

                this.cespiti.idasset_type = res.data.asset.idassettype;

                this.cespiti.tipo_disco = res.data.asset.tipo_disco;

                this.cespiti.pollici = res.data.asset.schermo_pollici;

                $("#itemIdAssetType").addClass("item-has-value");

                $("#itemRisorsa").addClass("item-has-value");

                this.syncOfficeRes(res.data.asset.idresource);


                if (res.data.asset.filename != null) {

                    $('.dropify-render').append("<i class='dropify-font-file'></i>");
                    $('.dropify-render').append("<span class='dropify-extension'>pdf</span>");

                    // dropify-font-file
                    $(".dropify-wrapper").addClass("has-preview");
                    $(".dropify-preview").show("slow");

                }






            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("Errori", "Non è stato possibile caricare i dati");
                console.log("response", response);

            }

            );

        },




        syncBanca: async function () {

            var that = this;

            var v_token = window.$cookies.get("token");

            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            var response = await apibanche.getBanca(
                that.$route.params.id,
                v_token
            ).then((res) => {

                that.$root.$children[0].showProgress = false;
                console.log("res from getBanca", res);

                this.aziende = res.data.aziende;

                this.gruppi = res.data.invoice_mail_group;

                this.banca = res.data.banca;


            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("Errori", "Non è stato possibile caricare i dati");
                console.log("response", response);

            }

            );

        },



        syncPrefix: async function () {

            var that = this;

            //var v_token = window.$cookies.get("token");

            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            var response = await apiusers.getPrefix().then((res) => {

                that.$root.$children[0].showProgress = false;
                console.log("res from getPrefix", res);

                try {

                    this.prefissi = res.data.tel_prefix;

                } catch (error) {
                    console.log(error);
                }

            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("ERrori", "Non è stato possibile caricare i dati");
                console.log("response", response);

            }

            );

        }

    }

})
</script>

<style>
#firmaCanvas {
    border: 1px solid black;
}

.clSelPopupCandidati {
    transform: translate(454px, -58px);
    cursor: pointer;
}

.titleSignature {
    margin-top: 10px;
    text-align: center;
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 0px;
}

.subtitleSignature {
    margin-top: 10px;
    text-align: center;
    font-weight: bold;
    font-size: 13px;
    margin-top: 0px;
}



canvas {
    border: 1px solid #c7c4a9;
    margin-top: 10px;
}

#container-view-pdf {
    display: flex;
    flex-direction: column;
    align-items: center;
}


.cl_importo {
    padding-left: 0px !important;
}


.itemAzienda {
    margin-left: 15px;
}

.itemRisorsa {
    margin-left: 15px;
}

.headerSheetAziende {
    position: fixed;
    z-index: 2;
    min-width: 100vw;
    background: white;
}

.headerSheetRisorse {
    position: fixed;
    z-index: 2;
    min-width: 100vw;
    background: white;
}

.itemGruppo {
    margin-left: 15px;
}

.headerSheetGruppi {
    position: fixed;
    z-index: 2;
    min-width: 100vw;
    background: white;
}





.closeSheet {
    position: absolute;
    right: 10px;
    top: 26px;
    z-index: 2;
}

.w-container-creaz-coll {
    width: 500px;
    padding: 0px;
}

.v-form {
    margin-top: 41px;
}

.mainTitle {
    padding: 20px !important;
    position: fixed;
    min-width: 500px;
    z-index: 1;
    top: 67px;
    border: 1px solid black;
}

.editCreazColl {
    overflow-x: hidden;
}

.editCreazColl .v-form {
    margin-top: 41px;
    padding-left: 10px;
    padding-right: 10px;
}

.editCreazColl .v-input {
    font-size: 1.2em !important;
}

.editCreazColl .v-select {
    font-size: 1.2em !important;
}

.editCreazColl .v-label {
    font-size: 1em !important;
}

.v-tabs:not(.v-tabs--vertical) .v-tab {
    white-space: normal;
    font-size: 12px;
    padding: 0px;
}

@media screen and (max-width: 768px) {

    .v-form {

        padding-top: 45px;
        padding-left: 16px;
        padding-right: 16px;
    }

    .w-container {
        width: 100vw;
        padding: initial;
        padding: inherit;
    }

    .mainTitle {
        padding: 20px !important;
        position: fixed;
        min-width: 100vw;
        left: 0;
        z-index: 1;
        top: 57px;
    }

    .w-container-creaz-coll {
        width: 100vw;
        padding: initial;
        padding: inherit;
    }

    .clSelPopupCandidati {
        transform: translate(370px, -58px);
        cursor: pointer;
    }



}

.theme--light.v-tabs>.v-tabs-bar,
.theme--light.v-tabs-items {
    background-color: transparent;
}
</style>
